// extracted by mini-css-extract-plugin
module.exports = {"closeButton":"CloseBanner_closeButton__4gA40"};